import React from 'react';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { FlagOutlined, StarOutlined } from '@ant-design/icons';

import { QuestionListItem, QuestionItem } from '../types';
import { LookStatus, lookStatus } from '../constant';

interface IProps {
  questionList: QuestionListItem[];
}

function AnswerList({ questionList }: IProps) {
  const { id, type }: { id: string, type: LookStatus } = useParams();
  const isReview = [lookStatus.review, lookStatus.view].includes(type);

  function onClickA(e: any, id: string) {
    e.preventDefault();
    const ele: any = document.getElementById(id);
    ele.scrollIntoView();
  }

  function computedCount(data: QuestionItem[]): number {
    let totalCount = 0;
    data.map(item => {
      totalCount += item.grade;
    })
    return totalCount;
  }

  return (
    <div className="content-left">
      <div className="content-left-top">
        <div className="title">
          <div className="line"></div>
          <div className="text">答题卡</div>
        </div>
        <ul className="ul-list">
          {
            questionList.map((test, index) => {
              return (
                <li className="ul-list-li" key={index}>
                  <div className="title">
                    {test.title}(共{test.questions.length}题，合计{computedCount(test.questions).toFixed(1)}分)
                  </div>
                  <ul className="ul-numbers">
                    {
                      test.questions.map((data, index2) => {
                        return (
                          <li className="ul-numbers-li" key={data.id}>
                            <a href={`#${data.id}`} onClick={(e) => onClickA(e, data.id)}>
                              <div className={
                                classnames("number", {
                                  right: isReview && data.isCorrect === 1,
                                  error: isReview && data.isCorrect === 0
                                })
                              }>{index2 + 1}</div>
                              {
                                lookStatus.view === type && (
                                  <div>
                                    {data.flag === 1 && <FlagOutlined style={{ color: '#1DA57A' }} />}
                                    {data.star === 1 && <StarOutlined style={{ color: '#FE8545' }} />}
                                  </div>
                                )
                              }
                            </a>
                          </li>
                        )
                      })
                    }
                  </ul>
                </li>
              )
            })
          }
        </ul>
      </div>
      <div className="content-left-bot">
        <div className="status">
          {
            (type === lookStatus.see) && (
              <div className="answered">
                <div className="icon hui"></div>
                <div className="value">未答</div>
              </div>
            )
          }
          <div className="answered">
            <div className="icon"></div>
            <div className="value">正确</div>
          </div>
          <div className="answered">
            <div className="icon red"></div>
            <div className="value">错误</div>
          </div>
          {
            (type === lookStatus.view) && (
              <div className="answered">
                <FlagOutlined style={{ color: '#1DA57A', marginRight: 5 }} />
                <div className="value">标记</div>
              </div>
            )
          }
          {
            (type === lookStatus.view) && (
              <div className="answered">
                <StarOutlined style={{ color: '#FE8545', marginRight: 5 }} />
                <div className="value">收藏</div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default AnswerList;
